import { Link } from 'react-router-dom';

const quickLinks = [
  { href: '/', label: '首页' },
  { href: '/category/origin', label: '品种起源' },
  { href: '/category/appearance', label: '外形特征' },
  { href: '/category/breeding', label: '养殖技术' },
  { href: '/about', label: '关于我们' },
];

const resourceLinks = [
  { href: '/category/feeding', label: '饲养管理' },
  { href: '/category/market', label: '市场价值' },
  { href: '/article/dajiba-breeding-tech', label: '养殖技术攻略' },
  { href: '/article/dajiba-feeding-guide', label: '饲养管理手册' },
  { href: '/article/dajiba-market-analysis', label: '市场价值分析' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold font-heading mb-4">
              大鸡巴品种科普
            </h4>
            <p className="text-sm text-background-50/80 leading-relaxed">
              致力于推广中国特色家禽品种知识，为养殖爱好者和农业从业者提供专业、权威的科普内容，助力科学养殖事业发展。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading mb-4 uppercase tracking-wide">
              快速导航
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-50/80 hover:text-background-50 cursor-pointer transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading mb-4 uppercase tracking-wide">
              推荐阅读
            </h4>
            <ul className="space-y-2">
              {resourceLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-50/80 hover:text-background-50 cursor-pointer transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading mb-4 uppercase tracking-wide">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-background-50/80">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>中国江苏省南京市玄武区农业科技示范园</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>025-8888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>info@dajiba-poultry.cn</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/60">
            &copy; {new Date().getFullYear()} 大鸡巴品种科普. 保留所有权利.
          </p>
          <p className="text-xs text-background-50/60">
            专注特色家禽品种知识普及 | 科学养殖，品质为本
          </p>
        </div>
      </div>
    </footer>
  );
}